import Receive from '../../components/receivePage/Receive';

export const ReceivePage = () => {
  return (
    <div>
      <Receive />
    </div>
  );
};
